<template>
  <div class="padding-10">
    <Toolbar></Toolbar>
    <FilterBar></FilterBar>
    <Table></Table>
  </div>
</template>

<script>
import Toolbar from "../components/customers/Toolbar";
import FilterBar from "../components/customers/Filter";
import Table from "../components/customers/Table";
export default {
  components: {
    Toolbar,
    FilterBar,
    Table,
  },
  mounted() {},
};
</script>

<style></style>
